module.exports = __webpack_public_path__ + "img/mr.2bee32d4.svg";